import { downForMaintenanceTypes } from 'lib/actions/types'

const setDownForMaintenance = payload => {
  return { type: downForMaintenanceTypes.SET_DOWN_FOR_MAINTENANCE, payload }
}

export { setDownForMaintenance }
